import { decideProfile, type Profile } from './profile';
import type { AskPlan, Assumed } from './types';
export const MAX_ASK_LENGTH = 4000;
export function decideAsk(raw: unknown): { ok: true; text: string } | { ok: false; reason: string } {
  if (typeof raw !== 'string' || !raw.trim()) return { ok: false, reason: 'empty_ask' };
  if (raw.length > MAX_ASK_LENGTH) return { ok: false, reason: 'ask_too_long' };
  return { ok: true, text: raw.trim().replace(/\s+/g, ' ') };
}
/** The teacher's explicit choices are authoritative, even against a malformed model plan. */
export function resolvePlan(plan: AskPlan, profile: Profile): AskPlan {
  if (plan.status === 'needs_more') return { status: 'needs_more', message: String(plan.message ?? '').slice(0, 500), example: String(plan.example ?? '').slice(0, 500) };
  if (plan.status !== 'ready') throw new Error('invalid_model_plan');
  const checked = decideProfile({ ...plan.profile, jurisdiction: profile.jurisdiction, ...(profile.academicSubject ? { academicSubject: profile.academicSubject } : {}), ...(profile.gradeLevels.length ? { gradeLevels: profile.gradeLevels } : {}) });
  if (!checked.ok) throw new Error('invalid_model_profile');
  const assumed: Assumed = {};
  if (!profile.gradeLevels.length && checked.profile.gradeLevels.length) assumed.gradeLevels = checked.profile.gradeLevels;
  if (!profile.academicSubject && checked.profile.academicSubject) assumed.academicSubject = checked.profile.academicSubject;
  const queries = Array.isArray(plan.queries) ? [...new Set(plan.queries.filter((q): q is string => typeof q === 'string').map(q => q.trim().slice(0, 600)).filter(Boolean))].slice(0, 4) : [];
  if (!queries.length) throw new Error('invalid_model_queries');
  return { status: 'ready', profile: checked.profile, assumed, queries };
}
